/**
 * A server action cannot throw `SessionExpiredError` across the client boundary
 * — Next redacts the message — so it returns this marker instead. See
 * `docs/meta-integration.md`.
 */
export const SESSION_EXPIRED_RESULT = { sessionExpired: true } as const;

export type SessionExpiredResult = typeof SESSION_EXPIRED_RESULT;

export function isSessionExpiredResult(
  value: unknown
): value is SessionExpiredResult {
  return (
    typeof value === "object" &&
    value !== null &&
    (value as { sessionExpired?: unknown }).sessionExpired === true
  );
}
